import ArticleIcon from "@mui/icons-material/Article";
import FacebookIcon from "@mui/icons-material/Facebook";
import FolderIcon from "@mui/icons-material/Folder";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkIcon from "@mui/icons-material/Link";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PublicIcon from "@mui/icons-material/Public";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";

/**
 * Maps URL type labels to their corresponding icons
 */
export const getUrlTypeIcon = (urlTypeLabel: string) => {
	switch (true) {
		case urlTypeLabel.toLowerCase().includes("linkedin"):
			return <LinkedInIcon />;
		case urlTypeLabel.toLowerCase().includes("website"):
			return <PublicIcon />;
		case urlTypeLabel.toLowerCase().includes("portfolio"):
			return <LinkIcon />;
		case urlTypeLabel.includes("X"):
			return <XIcon />;
		case urlTypeLabel.toLowerCase().includes("facebook"):
			return <FacebookIcon />;
		case urlTypeLabel.toLowerCase().includes("instagram"):
			return <InstagramIcon />;
		case urlTypeLabel.toLowerCase().includes("youtube"):
			return <YouTubeIcon />;
		case urlTypeLabel.toLowerCase().includes("blog"):
			return <ArticleIcon />;
		default:
			return null;
	}
};

/**
 * Maps document type labels to their corresponding icons
 */
export const getDocumentTypeIcon = (documentTypeLabel: string) => {
	switch (true) {
		case documentTypeLabel.toLowerCase().includes("portfolio"):
			return <FolderIcon />;
		case documentTypeLabel.toLowerCase().includes("blog"):
			return <ArticleIcon />;
		case documentTypeLabel.toLowerCase().includes("resume"):
			return <ContactPageOutlinedIcon />;
		default:
			return null;
	}
};
